// Import standards
import { useEffect, useState } from 'react';
import axios from '../config/api';
import { HashLink } from 'react-router-hash-link';

// Components
import PlaceholderCard from '../components/PlaceholderCard';
import CountryCard from "../components/CountryCard";

// Bulma Components
import { Heading, Container, Columns, Level, Tag, Menu } from 'react-bulma-components';

// Currency Page
const Currencies = () => {
    const [countries, setCountries] = useState([]);

    useEffect( () => {
        axios.get(`/all?fields=name,flags,coatOfArms,subregion,capital,population,region,currencies`)
        .then( (response) => {
            let data = response.data;
            setCountries(data);
        })
        .catch(error => console.error(error));

    }, []);

    // display nothing while countries is not loaded
    if(!countries.length) return "";

    //Add Sidemenu
      // Side menu for Region Page 
  const SideMenu = () => {
    
    // smooth scroll to element invoked
    // when a menu item is clicked
    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -80; 
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });

    }
    
    return (
        <Menu ml={5} pt={5} style={{ position: "fixed", top: "10px", bottom: "0", width: "240px" }} mt={6}>
            <Menu.List>
            {/* Side for African Subregions */}
            <Menu.List.Item className="menuItem" renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Currencies">
                <Menu.List title="Currencies">
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Dollars">Dollars ($)</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Euro">Euros (€)</Menu.List.Item>
                        <Menu.List.Item renderAs={HashLink} scroll={el => scrollWithOffset(el)} to="#Other">Other Currencies</Menu.List.Item>
                    </Menu.List>
                </Menu.List.Item>
            </Menu.List>
        </Menu>
    )
  };

    // Currency Components as a means to avoid hard coding
    const CurrencySection = (props) => {
        const [currency, setCurrency] = useState([]);
    
        useEffect(() => {
            setCurrency(countries.filter(country => {
                if(country?.currencies) {
                    let currency = Object.values(country.currencies).map(value => value.symbol);
                    // console.log(currency[0] ,props.currency);
    
                    if (currency[0] === props.currency) {
                        return country;
                    }
                }

                if(!country?.currencies && !props.currency) {
                    let currency = Object.values(country.currencies).map(value => value.symbol);
                    // console.log(currency[0] ,props.currency);
                    console.log(currency);
    
                    if (currency[0] !== "$" && currency[0] !== "€") {
                        return country;
                    }
                }
                // console.log(country.currencies);
            }));
        }, [props.currency]);
        
        const CurrencyCards = currency.map((country, i) => {
            return <CountryCard display="flex" size="4" key={`${country.name.common}CurrencyCard${i}`} flags={country.flags.png} coatOfArms={country.coatOfArms.png} name={country.name.common} region={country.subregion} capital={country.capital} population={country.population}/>
        });
    
        // const removeTextSpace = props.subregion.replace(" ", "");
    
        let TemplateCards = [];
        for(let i = 0; i < 15; i++) {
        TemplateCards.push(
             <PlaceholderCard size="4" key={`templateCard${i}`}/>
        )
        }

        const currencyTitle = (props.currency === "$" ? "Dollars" : "Euro");
    
        return (
          <>
            <Columns.Column size={12}>
                <Tag.Group renderAs={HashLink} smooth to={`#${currencyTitle}`} id={`${currencyTitle}`} hasAddons>
                    <Tag rounded color="warning" size="large">
                        # {currencyTitle}
                    </Tag>
                    <Tag rounded color="text" size="large">
                        {CurrencyCards.length} countries
                    </Tag>
                </Tag.Group>
            </Columns.Column>
                {(currency.length) ? CurrencyCards : TemplateCards}
            <Columns.Column size={12}>
            <hr className="has-background-white-ter"/>
            </Columns.Column>
          </>
        );
    };
    

    const NoCurrencySection = (props) => {
        const [currency, setCurrency] = useState([]);
    
        useEffect(() => {
            setCurrency(countries.filter(country => {

                if(country?.currencies) {
                    let currency = Object.values(country.currencies).map(value => value.symbol);
                    // console.log(currency[0] ,props.currency);
    
                    if (currency[0] !== "$" && currency[0] !== "€") {
                        return country;
                    }
                }
                // console.log(country.currencies);
            }));
        }, [props.currency]);
        
        const CurrencyCards = currency.map((country, i) => {
            return <CountryCard display="flex" size="4" key={`${country.name.common}NoCurrencyCard${i}`} flags={country.flags.png} coatOfArms={country.coatOfArms.png} name={country.name.common} region={country.subregion} capital={country.capital} population={country.population}/>
        });
    
        // const removeTextSpace = props.subregion.replace(" ", "");
    
        let TemplateCards = [];
        for(let i = 0; i < 15; i++) {
        TemplateCards.push(
             <PlaceholderCard size="4" key={`templateCard${i}`}/>
        )
        }
    
        return (
          <>
            <Columns.Column size={12}>
                <Tag.Group renderAs={HashLink} smooth to="#Other" id="Other" hasAddons>
                    <Tag rounded color="warning" size="large">
                        # Other
                    </Tag>
                    <Tag rounded color="text" size="large">
                        {CurrencyCards.length} countries
                    </Tag>
                </Tag.Group>
            </Columns.Column>
                {(currency.length) ? CurrencyCards : TemplateCards}
            <Columns.Column size={12}>
            <hr className="has-background-white-ter"/>
            </Columns.Column>
          </>
        );
    };

    // Placeholder cards to display while actual cards load
    let TemplateCards = [];
    for(let i = 0; i < 15; i++) {
    TemplateCards.push(
         <PlaceholderCard key={`templateCard${i}`}/>
    )
    }

    return (
        <>

        <SideMenu/>

        <div className="has-background-white-bis">
            <Container breakpoint="desktop" max="desktop" pt={6}>
                
                <Columns mt="auto">
                <Columns.Column size={12} mt="auto">
                <Level id="Currencies">
                    <Level.Item renderAs={Columns.Column} align="left">
                    <Heading textSize={3} textWeight="bold"><span className="is-size-2 has-text-grey-lighter">#</span> Currencies</Heading>
                    </Level.Item>
                </Level>
                </Columns.Column>

                    {/* Countries categorised in its currencies */}
                    {countries.length ? (
                        <>
                            <CurrencySection currency="$"/>
                            <CurrencySection currency="€"/>
                            <NoCurrencySection/>
                        </>
                    ) : null}

                </Columns>
            </Container>
        </div>
        </>
    );
};

export default Currencies;